var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.748 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-eye",
    d: "M16.671-12.105A18.793,18.793,0,0,0,0-22.5,18.8,18.8,0,0,0-16.671-12.1a1.886,1.886,0,0,0-.2.853,1.9,1.9,0,0,0,.2.857A18.793,18.793,0,0,0,0,0,18.8,18.8,0,0,0,16.671-10.4a1.886,1.886,0,0,0,.2-.853A1.9,1.9,0,0,0,16.671-12.105ZM0-2.812A8.442,8.442,0,0,1-8.437-11.25,8.442,8.442,0,0,1,0-19.687,8.442,8.442,0,0,1,8.438-11.25v0A8.437,8.437,0,0,1,0-2.812ZM0-16.875a5.578,5.578,0,0,0-1.483.222,2.79,2.79,0,0,1,.544,1.659,2.8,2.8,0,0,1-2.8,2.8,2.793,2.793,0,0,1-1.66-.543,5.611,5.611,0,0,0-.2,1.472A5.615,5.615,0,0,0,.014-5.649a5.615,5.615,0,0,0,5.612-5.612A5.615,5.615,0,0,0,.014-16.873Z",
    transform: "translate(16.874 22.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEye);
export default __webpack_public_path__ + "static/media/ico-eye.d2a2e9720b84a03cc7ab7eda2a35f34c.svg";
export { ForwardRef as ReactComponent };